import ParentDashboardTypes from './parentDashboard.types';
import { takeLatest, call, put, all, select } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import Api from '../../utils/Api';
import { clearLocalStorage } from '../../utils/commonFunctions';
import UtilsTypes from '../utilities/utils.types';
import Loader from '../../utils/Loader';
import {
	getChildDetails,
	getChildToken,
	getActiveChild,
} from './parentDashboard.selector';
import { getUserDetails } from '../userAuthentication/userAuth.selectors';
import { tagEvent } from '../../utils/tagManager';
import { UPDATE_ACTIVE_COURSE } from '../userAuthentication/userAuth.actionTypes';

function* setError(msg) {
	if (msg === 'Token is Invalid' || msg === 'Token is missing') {
		clearLocalStorage();
		yield put(push('/'));
	} else {
		yield put({ type: UtilsTypes.SET_ERROR_MSG, payload: msg });
	}
	Loader.hide();
}

function* setErrorPanel(errorPanel) {
	Loader.hide();
	yield put({ type: UtilsTypes.SET_ERROR_PANEL, payload: errorPanel });
}

function* addChild({ payload }) {
	try {
		const { child_photo, child_name, child_grade } = payload;
		const data = new FormData();
		data.append('child_photo', child_photo[0]);
		data.append('child_name', child_name);
		data.append('child_grade', child_grade);

		const res = yield call(Api, {
			url: 'childprofile',
			method: 'POST',
			data: data,
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setErrorPanel, {
				panelMsg: res,
				panelClass: 'alert alert-danger',
			});
		} else {
			if (res.code === 200) {
				Loader.hide();
				yield call(setErrorPanel, {});
				yield put({ type: ParentDashboardTypes.ADD_CHILD_DETAILS.SUCCESS });
				yield put({ type: ParentDashboardTypes.SHOW_ADD_CHILD, payload: false });
				yield put({
					type: ParentDashboardTypes.GET_CHILDREN_LIST.PENDING,
				});
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('parent dashboard', err);
	}
}

function* editChild({ payload }) {
	try {
		const { child_photo, child_name, child_grade, child_id, is_delete } = payload;
		const data = new FormData();
		data.append('child_photo', !!child_photo ? child_photo[0] : '');
		data.append('child_name', child_name);
		data.append('child_grade', child_grade);
		data.append('child_id', child_id);
		if (!!is_delete) {
			data.append('is_delete', is_delete);
		}

		const res = yield call(Api, {
			url: 'childprofile',
			method: 'PUT',
			data: data,
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setErrorPanel, {
				panelMsg: res,
				panelClass: 'alert alert-danger',
			});
		} else {
			if (res.code === 200) {
				Loader.hide();
				yield call(setErrorPanel, {});

				yield put({ type: ParentDashboardTypes.SHOW_EDIT_CHILD, payload: false });
				yield put({
					type: ParentDashboardTypes.GET_CHILDREN_LIST.PENDING,
				});
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('parent dashboard', err);
	}
}

function* fetchChildrenList() {
	try {
		const res = yield call(Api, {
			url: 'childprofile',
			method: 'GET',
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			Loader.hide();
			if (res.message !== 'No child exist for this parent') {
				//	yield put(push('/parent/dashboard'));
			} else {
				yield call(setError, res.message);
			}
			yield put({
				type: ParentDashboardTypes.GET_CHILDREN_LIST.FAILURE,
			});
		} else {
			Loader.hide();
			if (res.is_parentpurchased) {
				yield put({
					type: ParentDashboardTypes.SET_HAS_LICENSE,
					payload: res.is_parentpurchased,
				});
			}
			if (res.message !== 'No child exist for this parent') {
				//yield put(push('/parent/dashboard'));
				yield put({
					type: ParentDashboardTypes.GET_CHILDREN_LIST.SUCCESS,
					payload: res.data,
				});
			} else {
				yield put({
					type: ParentDashboardTypes.GET_CHILDREN_LIST.SUCCESS,
					payload: res.data,
				});
			}
		}
	} catch (err) {
		console.log('parent dashboard', err);
	}
}

function* fetchChildToken({ payload }) {
	const { child_id, id } = payload;
	try {
		const res = yield call(Api, {
			url: `usertoken`,
			method: 'POST',
			data: {
				child_id,
			},
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res.message);
		} else {
			Loader.hide();
			yield put({
				type: ParentDashboardTypes.GET_CHILD_TOKEN.SUCCESS,
				payload: { activeChildId: id, childToken: res.data.token },
			});
			yield put(push(`/child/dashboard/${id}`));
		}
	} catch (err) {
		console.log('parent dashboard', err);
	}
}

function* updateParentName({ payload }) {
	const {
		receiveWhatsappNotification,
		parentName: full_name,
		whatsappNumber,
	} = payload;
	try {
		const res = yield call(Api, {
			url: 'childprofile',
			method: 'POST',
			data: {
				parent_name: full_name,
				receiveWhatsappNotification: receiveWhatsappNotification ? '1' : '0',
				whatsappNumber,
			},
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setErrorPanel, {
				panelMsg: res,
				panelClass: 'alert alert-danger',
			});
		} else {
			if (res.code === 200 || res.code === 201) {
				Loader.hide();
				yield put({
					type: ParentDashboardTypes.UPDATE_PARENT_NAME.SUCCESS,
					payload: { parentName: payload.parentName },
				});
			} else {
				yield call(setErrorPanel, {
					panelMsg: res.message,
					panelClass: 'alert alert-danger',
				});
			}
		}
	} catch (err) {
		console.log('parent dashboard', err);
	}
}

function* getChildCourse({ payload }) {
	const token = yield select(getChildToken);

	try {
		const res = yield call(Api, {
			url: `courses/${payload}/1`,
			method: 'GET',
			headers: { 'access-token': token || localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res.message);
			yield put({
				type: ParentDashboardTypes.GET_CHILD_COURSE.FAILURE,
			});
		} else {
			Loader.hide();
			yield put({
				type: ParentDashboardTypes.GET_CHILD_COURSE.SUCCESS,
				payload: res.data.coursedetails,
			});
		}
	} catch (err) {
		console.log('parent dashboard', err);
	}
}

function* getChildSpeechCourse({ payload }) {
	const token = yield select(getChildToken);

	try {
		const res = yield call(Api, {
			url: `courses/${payload}/1`,
			method: 'GET',
			headers: { 'access-token': token || localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res.message);
			yield put({
				type: ParentDashboardTypes.GET_CHILD_SPEECH_COURSE.FAILURE,
			});
		} else {
			Loader.hide();
			yield put({
				type: ParentDashboardTypes.GET_CHILD_SPEECH_COURSE.SUCCESS,
				payload: res.data.coursedetails,
			});
		}
	} catch (err) {
		console.log('parent dashboard', err);
	}
}

function* getProductDetails({ payload }) {
	const childList = yield select(getChildDetails);
	const token = yield select(getChildToken);
	const { product_id, child_id, product_course_id } = childList[payload];

	try {
		const res = yield call(Api, {
			url: `product/${product_id}/${child_id}`,
			method: 'GET',
			headers: { 'access-token': token },
		});
		if (!res.status) {
			yield call(setError, res.message);
			yield put({
				type: ParentDashboardTypes.GET_PRODUCT_DETAILS_CHILD.FAILURE,
			});
		} else {
			Loader.hide();
			yield put({
				type: ParentDashboardTypes.GET_PRODUCT_DETAILS_CHILD.SUCCESS,
				payload: res.data,
			});
			if (res.data.is_purchased) {
				yield put({
					type: ParentDashboardTypes.GET_CHILD_SPEECH_COURSE.PENDING,
					payload: product_course_id,
				});
			}
		}
	} catch (err) {
		console.log('parent dashboard', err);
	}
}

function* getChildReport({ payload }) {
	const token = yield select(getChildToken);

	try {
		const res = yield call(Api, {
			url: `kidsscore`,
			method: 'GET',
			headers: { 'access-token': token || localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res.message);
			yield put({
				type: ParentDashboardTypes.GENERATE_CHILD_REPORT.FAILURE,
			});
		} else {
			Loader.hide();
			yield put({
				type: ParentDashboardTypes.GENERATE_CHILD_REPORT.SUCCESS,
				payload: res.data.cert_url,
			});
			const { cert_url } = res.data;
			if (payload) {
				const { percentile, score, grade } = res.data;
				const childList = yield select(getChildDetails);
				const activeChild = yield select(getActiveChild);
				const user = yield select(getUserDetails);
				yield call(tagEvent, {
					event: 'kids_freetest_complete',
					user_id: user.userId,
					child_id: childList[activeChild].child_id,
					grade,
					score,
					percentile,
					certificate: cert_url,
				});
			} else {
				window.open(cert_url, '_blank');
			}
		}
	} catch (err) {
		console.log('parent dashboard', err);
	}
}

function* applyLicense() {
	try {
		let activeChildId = yield select(getActiveChild);
		let children = yield select(getChildDetails);
		const { child_grade, child_id } = children[activeChildId];
		if (!child_grade) {
			yield call(setErrorPanel, {
				panelMsg: 'Child Token not found!',
				panelClass: 'alert alert-danger',
			});
		} else {
			const res = yield call(Api, {
				url: 'change_grant',
				method: 'POST',
				data: {
					grade: child_grade,
					child_id: child_id,
				},
				headers: { 'access-token': localStorage.getItem('token') },
			});
			if (!res.status) {
				yield call(setErrorPanel, {
					panelMsg: res,
					panelClass: 'alert alert-danger',
				});
			} else {
				if (res.code === 200) {
					Loader.hide();
					yield call(setErrorPanel, {
						panelMsg: 'Redirecting you to your course...',
						panelClass: 'alert alert-success',
					});

					yield put({
						type: UPDATE_ACTIVE_COURSE,
						payload: res.data.course_id,
					});
					yield put({
						type: ParentDashboardTypes.GET_CHILD_TOKEN.PENDING,
						payload: { child_id, id: activeChildId },
					});
				} else {
					yield call(setErrorPanel, {
						panelMsg: res.message,
						panelClass: 'alert alert-danger',
					});
				}
			}
		}
	} catch (err) {
		console.log('mycourse', err);
	}
}

function* getChildLoginDetails({ payload }) {
	const token = yield select(getChildToken);

	try {
		const res = yield call(Api, {
			url: `childdetails`,
			method: 'GET',
			headers: { 'access-token': token || localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res.message);
			yield put({
				type: ParentDashboardTypes.GET_CHILD_DETAILS.FAILURE,
			});
		} else {
			Loader.hide();
			yield put({
				type: ParentDashboardTypes.GET_CHILD_DETAILS.SUCCESS,
				payload: { activeChildId: 0, childrenList: [res.data] },
			});
		}
	} catch (err) {
		console.log('parent dashboard', err);
	}
}

function* addChildStart() {
	yield takeLatest(ParentDashboardTypes.ADD_CHILD_DETAILS.PENDING, addChild);
}
function* editChildStart() {
	yield takeLatest(ParentDashboardTypes.EDIT_CHILD_DETAILS.PENDING, editChild);
}

function* updateParentNameStart() {
	yield takeLatest(
		ParentDashboardTypes.UPDATE_PARENT_NAME.PENDING,
		updateParentName,
	);
}

function* fetchChildrenListStart() {
	yield takeLatest(
		ParentDashboardTypes.GET_CHILDREN_LIST.PENDING,
		fetchChildrenList,
	);
}

function* fetchChildTokenStart() {
	yield takeLatest(
		ParentDashboardTypes.GET_CHILD_TOKEN.PENDING,
		fetchChildToken,
	);
}

function* getChildCourseStart() {
	yield takeLatest(
		ParentDashboardTypes.GET_CHILD_COURSE.PENDING,
		getChildCourse,
	);
}

function* getChildSpeechCourseStart() {
	yield takeLatest(
		ParentDashboardTypes.GET_CHILD_SPEECH_COURSE.PENDING,
		getChildSpeechCourse,
	);
}

function* getProductDetailsStart() {
	yield takeLatest(
		ParentDashboardTypes.GET_PRODUCT_DETAILS_CHILD.PENDING,
		getProductDetails,
	);
}

function* getChildReportStart() {
	yield takeLatest(
		ParentDashboardTypes.GENERATE_CHILD_REPORT.PENDING,
		getChildReport,
	);
}

function* applyLicenseStart() {
	yield takeLatest(ParentDashboardTypes.APPLY_LICENSE.PENDING, applyLicense);
}

function* getChildLoginDetailsStart() {
	yield takeLatest(
		ParentDashboardTypes.GET_CHILD_DETAILS.PENDING,
		getChildLoginDetails,
	);
}

export function* parentDashboardSagas() {
	yield all([
		call(addChildStart),
		call(editChildStart),
		call(fetchChildrenListStart),
		call(fetchChildTokenStart),
		call(updateParentNameStart),
		call(getChildCourseStart),
		call(getProductDetailsStart),
		call(getChildSpeechCourseStart),
		call(getChildReportStart),
		call(applyLicenseStart),
		call(getChildLoginDetailsStart),
	]);
}
